import { http } from './http.jsx';

export const deviceService = {
  // Get all devices
  getDevices: (params = {}) => http.get('/api/admin/devices', { params }),
  
  // Get single device
  getDevice: (deviceId) => http.get(`/api/admin/devices/${deviceId}`),
  
  // Create new device
  createDevice: (data) => http.post('/api/admin/devices', data),
  
  // Update device
  updateDevice: (deviceId, data) => http.put(`/api/admin/devices/${deviceId}`, data),
  
  // Delete device
  deleteDevice: (deviceId) => http.delete(`/api/admin/devices/${deviceId}`),
  
  // Get available sites for device assignment
  getDeviceSites: () => http.get('/api/admin/devices-sites'),
};
